<template>
  <span @click="getNewUrl">
    <i
      v-if="tooltip"
      v-b-tooltip.hover.html
      title="Clique para visualizar o manual do cliente!"
      style="font-size: 0.65rem"
      class="question-icon"
    >
      <font-awesome-icon :icon="faQuestionCircle" />
    </i>
    <div
      v-else
      class="hiper-link"
    >
      <span style="text-decoration: underline;">
        Dúvidas, clique aqui.
      </span>
    </div>
  </span>
</template>
<style>
.hiper-link {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  color: blue;
  cursor: pointer;
}
</style>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import api from '@/app-modulo/comuns/manual-cliente/shared/services/api'

export default {
  nome: 'manual-cliente',
  components: {
    FontAwesomeIcon,
  },
  props: {
    tooltip: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      faQuestionCircle,
    }
  },
  methods: {
    getNewUrl() {
      api.getUrlManual()
        .then(async paylod => {
          if (paylod.data) {
            window.open(paylod.data, '_blank')
          }
        })
        .catch(err => {
          this.$erro(err)
          throw err
        })
    },
  },
}
</script>
